import { detectPriceListPrices } from './elastic';

// Constant for namespace cos your IDE doesn't spot spelling errors in string.
const PLUGIN_NAMESPACE = 'qalaPriceListElastic';

wp.hooks.addAction(
	'qalaElasticCore.action.onResult.results',
	PLUGIN_NAMESPACE,
	detectPriceListPrices
);
